module.exports = __webpack_public_path__ + "static/media/L.52077910.jpg";